import React from 'react'
import { withIcon } from '../../withIcon'

function BookmarkIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
      <path d="M17.375 7C17.375 6.10489 17.0197 5.24622 16.3867 4.61328C15.7538 3.98035 14.8951 3.625 14 3.625H10C9.10489 3.625 8.24622 3.98035 7.61328 4.61328C6.98035 5.24622 6.625 6.10489 6.625 7V19.8311L11.6533 16.4795L11.7344 16.4336C11.9302 16.3417 12.163 16.3571 12.3467 16.4795L17.375 19.8311V7ZM18.625 21C18.625 21.2305 18.4981 21.442 18.2949 21.5508C18.0918 21.6595 17.8451 21.6482 17.6533 21.5205L12 17.751L6.34668 21.5205C6.15493 21.6482 5.90822 21.6595 5.70508 21.5508C5.50192 21.442 5.375 21.2305 5.375 21V7C5.375 5.77337 5.86214 4.59685 6.72949 3.72949C7.59685 2.86214 8.77337 2.375 10 2.375H14C15.2266 2.375 16.4032 2.86214 17.2705 3.72949C18.1379 4.59685 18.625 5.77337 18.625 7V21Z" fill={color}/>
    </svg>
  )
}

export default withIcon(BookmarkIcon)
